import { useMemo } from "react";
import { appVersion } from "@/config/env";
import { Logo } from "@/shared/components/common/Logo";
import { usePageLayout } from "@/app/hooks/usePageLayout";

export function AppInfoRoute() {
  const pageLayoutConfig = useMemo(() => ({ navbar: { title: "App Info" } }), []);
  usePageLayout(pageLayoutConfig);

  return (
    <>
      <div className="flex h-full flex-col items-center justify-center">
        <Logo size={80} />
        <span>InkRows</span>
        <span className="text-default-500 text-sm">Version {appVersion}</span>
      </div>
    </>
  );
}
